import { Championship, ChampionshipLeague } from "../../../types";

export const getLeagueInfo = (championship?: Championship, leagueId?: string): ChampionshipLeague | null => {
	if (!championship?.settings?.leagues || !leagueId) {
		return null;
	}
	const leagues = championship.settings.leagues || [];
	return leagues.find((e) => e.id === leagueId);
};
